import React from 'react'
import { connect } from "react-redux";
import classnames from "classnames";

import Loader from './shared/Loader'
// import Button from './shared/Button';
import { Link } from "react-router-dom";
import baseStyles from 'custom/base.styl';

import checkIcon from 'custom/checkIcon';

const PageSuccess = (props) => {

  if (props.isFetching) {
    return <Loader absolute />
  }

  return (
    <div className={baseStyles.animate_form}>
      <div className={classnames(baseStyles.header)} key="registration-success-header">
        <h2 className={baseStyles.title_middle}>Success!</h2>
      </div>
      <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-content">
        {checkIcon()}
        {/* <img className={baseStyles.content_board__icon} src={check} alt="" width="72px" /> */}
				<p className={classnames(baseStyles.title_extra_small, baseStyles.mb_20)}>Your temporary password<br/>is already on your email!</p>
        <Link to='/login'>Go to Login page</Link>
        {/* <Button link onClick={() => props.history.push('/login')}>Go to Login page</Button> */}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isFetching: state.profile.isFetching,
})

export default connect(mapStateToProps)(PageSuccess);



// WEBPACK FOOTER //
// ./src/components/PageSuccess.js